import { snowplowButtonClick } from '@analytics/snowplow/events';
import { IconsEnum } from '@components/icons/types';
import {
  PlanCardBenefit,
  PlanCardBenefitHighlight,
  PlanCardBenefitList,
} from '@screens/lp-default/components/plans/styles';

export const PlanCardContents = [
  {
    title: 'Free',
    icon: IconsEnum['paper-plane-tilt'],
    description: 'Acesse conteúdos essenciais gratuitamente e tenha o Whitebook como seu aliado clínico.',
    buttonText: 'Criar conta',
    buttonClick: () => {
      snowplowButtonClick('signup', '/planos', 'free_plan_card', 'plans_section');
      window.location.href = `${process.env.NEXT_PUBLIC_APP_URL}/cadastro?step=1`;
    },
    benefits: (
      <PlanCardBenefitList>
        <PlanCardBenefit>Medicamentos</PlanCardBenefit>
        <PlanCardBenefit>Códigos CID 10, SUS e TUSS</PlanCardBenefit>
        <PlanCardBenefit>Radar Whitebook</PlanCardBenefit>
      </PlanCardBenefitList>
    ),
    isHighlighted: false,
    tag: null,
    showOffers: false,
  },
  {
    title: 'Premium',
    icon: IconsEnum['crown-simple'],
    description: 'Desbloqueie todo o conteúdo exclusivo e tenha suporte completo na sua prática médica.',
    buttonText: 'Assine agora',
    buttonClick: () => {
      snowplowButtonClick('subscribe_button', '/planos', 'premium_plan_card', 'plans_section');
      window.location.href = process.env.NEXT_PUBLIC_PAYMENT_METHOD_CHECKOUT;
    },
    benefits: (
      <div>
        <PlanCardBenefitHighlight>Todos os benefícios do Free e mais:</PlanCardBenefitHighlight>
        <PlanCardBenefitList>
          <PlanCardBenefit>Calculadoras e Escores</PlanCardBenefit>
          <PlanCardBenefit>Prescrições</PlanCardBenefit>
          <PlanCardBenefit>Condutas por Especialidades</PlanCardBenefit>
          <PlanCardBenefit>Diagnóstico Diferencial</PlanCardBenefit>
          <PlanCardBenefit>Fluxogramas Interativos</PlanCardBenefit>
          <PlanCardBenefit>Diversos outros conteúdos</PlanCardBenefit>
        </PlanCardBenefitList>
      </div>
    ),
    isHighlighted: true,
    tag: 'Recomendado',
    showOffers: true,
  },
  {
    title: 'Corporativo',
    icon: IconsEnum.buildings,
    description: 'Leve o Whitebook para sua empresa, com planos personalizados.',
    buttonText: 'Entre em contato',
    buttonClick: () => {
      snowplowButtonClick('corporate_offer', '/planos', null, 'plans_section');
      window.location.href = 'mailto:felipe.nascimento@iclinic.com.br';
    },
    benefits: (
      <PlanCardBenefitList>
        <PlanCardBenefit>
          <span>
            <strong>Para sua equipe ou clientes:</strong> Ofereça o plano Premium e garanta acesso a ferramentas e
            conteúdos médicos de qualidade.
          </span>
        </PlanCardBenefit>
        <PlanCardBenefit>
          <span>
            <strong>Planos personalizados:</strong> Preços flexíveis, ajustados ao tamanho da sua instituição.
          </span>
        </PlanCardBenefit>
      </PlanCardBenefitList>
    ),
    isHighlighted: false,
    tag: null,
    showOffers: false,
  },
];
